import { useEffect, useRef } from 'react';

import isEmpty from 'lodash/isEmpty';

import { useDispatch, useSelector } from 'react-redux';

import { RootState, UrlUtils, Responsive } from '@share/utils';
import { GetawayList, ResultWrapper, SkeletonResult } from '@components';
import { getLocationByCode } from '@share/services';
import { locationActions, resetHotelsFullAshevillePlayLocation } from '@share/store/slices';
import { GetawaysLocationEnum, ILocation } from '@share/common-types';

import { SearchAshevillePlayRealDiscountMessage } from './search-ashevilleplay-real-discount-message';
import { SearchAshevillePlayTrustedBrands } from './search-ashevilleplay-trusted-brands';
import { SearchAshevillePlayExitingTours } from './search-ashevilleplay-exiting-tours';
import { SearchAshevillePlayNewsEvents } from './search-ashevilleplay-news-events';
import { SearchAshevillePlayBestDeals } from './search-ashevilleplay-best-deals';
import { SearchAshevillePlayHeader } from './search-ashevilleplay-header';
import { SearchAshevillePlayCall } from './search-ashevilleplay-call';
import { ACTION_IDS } from './search-ashevilleplay-header-bottom/component';

import './style.scss';
import { useIntl } from 'react-intl';

export function SearchAshevillePlay() {

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  const locationsStore = useSelector((state: RootState) => state.locationsStore);
  const datesStore = useSelector((state: RootState) => state.datesStore);

  const { isSearch, hotels, loading, searchedLocation, error } = hotelsStore;
  const { account } = loginStore;

  const isAshevillePlay = account?.isAshevillePlay;
  const ashevillePlayLocationCode = account?.ashevillePlayLocationCode;

  const isAfterSearchLoad = (isSearch && !(!!locationsStore.error || !!datesStore.error)) || (hotels && !!hotels.length);

  const values = UrlUtils.getValues();

  const bestDealsRef = useRef<HTMLDivElement>(null);
  const toursRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  const intl = useIntl();

  const title = intl.formatMessage({ id: 'asheville.play.title' });
  const subtitle = intl.formatMessage({ id: 'asheville.play.subtitle' });

  useEffect(() => {
    if (isAshevillePlay && ashevillePlayLocationCode) {
      dispatch(resetHotelsFullAshevillePlayLocation());
    };
  }, [ashevillePlayLocationCode]);

  const handleScrollToBestDeals = () => {
    bestDealsRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  const handleScrollToTours = () => {
    toursRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  const handleClickHeader = (actionId: string) => {
    if (actionId === ACTION_IDS.BOOK_NOW) {
      handleScrollToBestDeals();
    } else if (actionId === ACTION_IDS.UPGRADE_YOUR_TRIP) {
      handleScrollToTours();
    }
  };

  return (
    <div className="search-asheville-play">
      <SearchAshevillePlayHeader isAfterSearchLoad={isAfterSearchLoad} onClick={handleClickHeader} />

      {!isAfterSearchLoad && 
        <>
          <SearchAshevillePlayBestDeals reference={bestDealsRef} />

          <SearchAshevillePlayRealDiscountMessage onClick={handleScrollToBestDeals} />

          <SearchAshevillePlayTrustedBrands />

          <SearchAshevillePlayExitingTours reference={toursRef} />
          
          {/*<GetawayList
            getaway={GetawaysLocationEnum.Staycation}
            condoSubcategory={null}
          
            title={title}
            subtitle={subtitle}

            isFromProperty
            isInternal
            isHome
            isSlider
            hideFilter
            displayTopHeader
          />*/}

          <SearchAshevillePlayNewsEvents />

          <SearchAshevillePlayCall onClick={handleScrollToBestDeals} />
        </>}
      
      {hotels && loading && isEmpty(error) && (
        <SkeletonResult label={searchedLocation} />)}

      {(!isEmpty(values) && !loading && (hotels || !isEmpty(error))) ? (
        <Responsive>
          <ResultWrapper label={searchedLocation} isVacationRentals={false} />
        </Responsive>) : null}
    </div>
  );
}
